// extracted by mini-css-extract-plugin
export var compact = "_nc-2";
export var phoneFrame = "_nc-0";
export var phoneScreen = "_nc-1";